// Imports
import TBBlogo from "./Assets/tbb_logo.png";
import KBBlogo from "./Assets/kbb_logo.png";
import NYlogo from "./Assets/logonoktasal.png";

const _mapSettings = [
  {
    _serverUrl: process.env.NODE_ENV === "production" ? "https://levha.trabzon.bel.tr/nlapi" : "http://localhost:3015",
    _socketUrl: process.env.NODE_ENV === "production" ? "https://levha.trabzon.bel.tr/" : "https://levha.trabzon.bel.tr/",
    _hostname: process.env.REACT_APP_NODE_ENV === "production" ? "levha.trabzon.bel.tr" : "localhost",
    name: "Trabzon Belediyesi Levha",
    logo: TBBlogo,
    id: 0,
    plaka: 61,
    imageType: "2",
    projection: "EPSG:4326",
    extent: [38.991633659811505, 40.12254348082656, 40.699834669551784, 41.574217776430494],
  },
  {
    _serverUrl: process.env.NODE_ENV === "production" ? "https://sahacbs.kocaeli.bel.tr/apisahacbs" : "http://localhost:3010",
    _socketUrl: process.env.NODE_ENV === "production" ? "https://sahacbs.kocaeli.bel.tr/" : "https://sahacbs.kocaeli.bel.tr/",
    _hostname: process.env.REACT_APP_NODE_ENV === "production" ? "sahacbs.kocaeli.bel.tr" : "localhost",
    name: "CBS Saha Tespit Uygulaması",
    logo: KBBlogo,
    id: 1,
    plaka: 41,
    extent: [29.3219312, 40.5279772, 30.4304194, 41.2186949],
  },
  {
    name: "Şanlıurfa Belediyesi Levha",
    id: 2,
    plaka: 63,
    extent: [37.25802934404738, 35.843306945832154, 40.97581066727651, 39.29000004757583],
  },
  {
    _serverUrl: process.env.NODE_ENV === "production" ? "http://10.250.10.119/api" : "http://localhost:3015",
    _socketUrl: "http://localhost:3111",
    name: "Bodrum Belediyesi Levha",
    logo: NYlogo,
    id: 3,
    plaka: 35,
    zoom: 11,
    imageType: "1",
    projection: "EPSG:3857",
    center: [3054026.177962, 4445997.968721],
  },
];

// 0 : Trabzon
// 1 : Kocaeli
// 2 : Şanlıufa
// 3 : Bodrum
export const _selectedMapSettings = _mapSettings[0]; // BURASI DEĞİŞTİRİLİR

// Config
export const _appName = _selectedMapSettings.name;
export const _serverUrl2 = _selectedMapSettings._serverUrl;
export const _socketUrl = _selectedMapSettings._socketUrl;
export const _clientName = _selectedMapSettings.name;
export const _clientLogo = _selectedMapSettings.logo;
export const _projection = _selectedMapSettings.projection;
export const _plaka = _selectedMapSettings.plaka
export const _isTrabzon = _selectedMapSettings == _mapSettings[0] ? true : false;

export const _serverUrl = "https://nolevs.noktasal.com.tr/apinolevs";
